import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { CONSTANTS_COMMENTS, PARAMS } from './constants';
import * as style from './LandingSliderPhoto.scss';
import images from '../../../static/images/RealtorLanding';

const swiperParams = {
  speed: 500,
  slidesPerView: 4,
  centeredSlides: true,
  loop: true,
  slidesPerGroupAuto: true,
  spaceBetween: 30,
  breakpoints: {
    1600: {
      slidesPerView: 3.5
    },
    1370: {
      slidesPerView: 2.5
    },
    1000: {
      slidesPerView: 1.5
    }
  }
};

const swiperMobileParams = {
  speed: 500,
  centeredSlides: true,
  slidesPerGroupAuto: true,
  spaceBetween: 30,
  loop: true
};

class LandingSliderPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlideIndex: 0
    };
  }

  setRef = (ref) => {
    this.swiperRef = ref ? ref.swiper : null;
  };

  mappedItems = (item) => (
    <div className={style.sliderWrapper}>
      <img src={item} alt="realtor" />
    </div>
  );

  next = () => {
    if (this.swiperRef) {
      this.swiperRef.slideNext();
    }

    this.setState((prevState) => ({
      activeSlideIndex: prevState.activeSlideIndex < CONSTANTS_COMMENTS.length - 1
        ? prevState.activeSlideIndex + 1
        : 0
    }));
  };

  previous = () => {
    if (this.swiperRef) {
      this.swiperRef.slidePrev();
    }

    this.setState((prevState) => ({
      activeSlideIndex: prevState.activeSlideIndex > 0
        ? prevState.activeSlideIndex - 1
        : CONSTANTS_COMMENTS.length - 1
    }));
  };

  render() {
    const params = !this.props.isMobile ? swiperParams : swiperMobileParams;

    return (
      <div className={style.containerSlider}>
        <img
          src={images.prevArrow}
          className={style.arrowDesktop}
          onClick={this.previous}
          alt=""
        />
        <div className={style.slicSlider}>
          <Swiper {...params} ref={this.setRef}>
            {CONSTANTS_COMMENTS.map(this.mappedItems)}
          </Swiper>
        </div>
        <img
          src={images.nextArrow}
          className={style.arrowDesktop}
          onClick={this.next}
          alt=""
        />
        <div className={style.buttonWrapper}>
          <img src={images.prevArrow} onClick={this.previous} alt="" />
          <img src={images.nextArrow} onClick={this.next} alt="" />
        </div>
      </div>
    );
  }
}

LandingSliderPhoto.propTypes = {
  isRtl: PropTypes.bool,
  isMobile: PropTypes.bool
};

export default LandingSliderPhoto;
